module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-hocker-07.8f792df2.jpeg";